"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var antd_1 = require("antd");
var Option = antd_1.Select.Option;
var en_US_1 = __importDefault(require("../../../locale/en_US"));
var _get = require('lodash/get');
require("./WfsParserInput.css");
/**
 * WfsParserInput
 */
var WfsParserInput = /** @class */ (function (_super) {
    __extends(WfsParserInput, _super);
    function WfsParserInput(props) {
        var _this = _super.call(this, props) || this;
        _this.onUrlChange = function (event) {
            var url = event.target.value;
            var urlValidation = {};
            if (url.length <= 0) {
                urlValidation = {
                    status: 'error',
                    message: 'Url is required'
                };
            }
            _this.setState({
                url: url,
                validation: __assign({}, _this.state.validation, { url: urlValidation })
            });
        };
        _this.onTypeNameChange = function (event) {
            var typeName = event.target.value;
            var typeNameValidation = {};
            if (typeName.length <= 0) {
                typeNameValidation = {
                    status: 'error',
                    message: 'TypeName is required'
                };
            }
            _this.setState({
                typeName: typeName,
                validation: __assign({}, _this.state.validation, { typeName: typeNameValidation })
            });
            _this.setState({ typeName: typeName });
        };
        _this.onVersionChange = function (version) {
            var versionValidation = {};
            if (version.length <= 0) {
                versionValidation = {
                    status: 'error',
                    message: 'Version is required'
                };
            }
            _this.setState({
                version: version,
                validation: __assign({}, _this.state.validation, { version: versionValidation })
            });
            _this.setState({ version: version });
        };
        _this.onFeatureIDChange = function (event) {
            var featureID = event.target.value;
            _this.setState({ featureID: featureID });
        };
        _this.onPropertyNameChange = function (propertyName) {
            _this.setState({ propertyName: propertyName });
        };
        _this.onMaxFeaturesChange = function (maxFeatures) {
            _this.setState({ maxFeatures: maxFeatures });
        };
        _this.onClick = function () {
            _this.props.onClick(_this.state);
        };
        _this.state = {
            url: 'https://ows.terrestris.de/geoserver/terrestris/ows',
            version: '1.1.0',
            typeName: 'terrestris:bundeslaender',
            maxFeatures: undefined,
            validation: {
                url: undefined,
                version: undefined,
                typeName: undefined,
                featureID: undefined,
                propertyName: undefined,
                maxFeatures: undefined,
                fetchParams: undefined
            }
        };
        return _this;
    }
    WfsParserInput.prototype.render = function () {
        var locale = this.props.locale;
        var _a = this.state, url = _a.url, version = _a.version, typeName = _a.typeName, maxFeatures = _a.maxFeatures, propertyName = _a.propertyName, featureID = _a.featureID;
        return (React.createElement("div", { className: "wfs-parser-input" },
            React.createElement(antd_1.Form.Item, { label: locale.urlLabel, validateStatus: _get(this.state, 'validation.url.status'), help: _get(this.state, 'validation.url.message'), hasFeedback: true, required: true },
                React.createElement(antd_1.Input, { value: url, onChange: this.onUrlChange })),
            React.createElement(antd_1.Form.Item, { label: locale.typeNameLabel, validateStatus: _get(this.state, 'validation.typeName.status'), help: _get(this.state, 'validation.typeName.message'), hasFeedback: true, required: true },
                React.createElement(antd_1.Input, { value: typeName, onChange: this.onTypeNameChange })),
            React.createElement(antd_1.Form.Item, { label: locale.versionLabel, validateStatus: _get(this.state, 'validation.version.status'), help: _get(this.state, 'validation.version.message'), hasFeedback: true, required: true },
                React.createElement(antd_1.Select, { style: { width: '100%' }, value: version, onChange: this.onVersionChange },
                    React.createElement(Option, { value: "1.0.0" }, "1.0.0"),
                    React.createElement(Option, { value: "1.1.0" }, "1.1.0"),
                    React.createElement(Option, { value: "1.1.3" }, "1.1.3"),
                    React.createElement(Option, { value: "2.0" }, "2.0"),
                    React.createElement(Option, { value: "2.0.2" }, "2.0.2"))),
            React.createElement(antd_1.Form.Item, { label: locale.featureIDLabel, validateStatus: _get(this.state, 'validation.featureID.status'), help: _get(this.state, 'validation.featureID.message'), hasFeedback: true },
                React.createElement(antd_1.Input, { value: featureID, onChange: this.onFeatureIDChange })),
            React.createElement(antd_1.Form.Item, { label: locale.propertyNameLabel, validateStatus: _get(this.state, 'validation.propertyName.status'), help: _get(this.state, 'validation.propertyName.message'), hasFeedback: true },
                React.createElement(antd_1.Select, { style: { width: '100%' }, mode: "tags", value: propertyName, onChange: this.onPropertyNameChange })),
            React.createElement(antd_1.Form.Item, { label: locale.maxFeaturesLabel, validateStatus: _get(this.state, 'validation.maxFeatures.status'), help: _get(this.state, 'validation.maxFeatures.message'), hasFeedback: true },
                React.createElement(antd_1.InputNumber, { style: { width: '100%' }, min: 0, value: maxFeatures, onChange: this.onMaxFeaturesChange, precision: 0 })),
            React.createElement(antd_1.Form.Item, null,
                React.createElement(antd_1.Button, { className: "wfs-parser-submit-button", type: "primary", onClick: this.onClick }, locale.requestButtonText))));
    };
    WfsParserInput.defaultProps = {
        locale: en_US_1.default.GsWfsParserInput
    };
    return WfsParserInput;
}(React.Component));
exports.WfsParserInput = WfsParserInput;
exports.default = WfsParserInput;
//# sourceMappingURL=WfsParserInput.js.map